// -------------------------------------------------------------------------------

// PLEASE DO NOT EDIT THIS FILE, IT IS GENERATED AND WILL BE OVERWRITTEN:
// https://github.com/ccxt/ccxt/blob/master/CONTRIBUTING.md#how-to-contribute-code

// -------------------------------------------------------------------------------

import { Dict } from '../base/types.js';
import { Exchange as _Exchange } from '../base/Exchange.js';

interface Exchange {
    privateEdgePostAuthApiKeyLogin (params?: {}): Promise<Dict>;
    privateEdgePostAuthWalletLogin (params?: {}): Promise<Dict>;
    publicMarketPostFullV1Instrument (params?: {}): Promise<Dict>;
    publicMarketPostFullV1AllInstruments (params?: {}): Promise<Dict>;
    publicMarketPostFullV1Instruments (params?: {}): Promise<Dict>;
    publicMarketPostFullV1Currency (params?: {}): Promise<Dict>;
    publicMarketPostFullV1MarginRules (params?: {}): Promise<Dict>;
    publicMarketPostFullV1Mini (params?: {}): Promise<Dict>;
    publicMarketPostFullV1Ticker (params?: {}): Promise<Dict>;
    publicMarketPostFullV1Book (params?: {}): Promise<Dict>;
    publicMarketPostFullV1Trade (params?: {}): Promise<Dict>;
    publicMarketPostFullV1TradeHistory (params?: {}): Promise<Dict>;
    publicMarketPostFullV1Kline (params?: {}): Promise<Dict>;
    publicMarketPostFullV1Funding (params?: {}): Promise<Dict>;
    privateTradingPostFullV1CreateOrder (params?: {}): Promise<Dict>;
    privateTradingPostFullV1CancelOrder (params?: {}): Promise<Dict>;
    privateTradingPostFullV1CancelOnDisconnect (params?: {}): Promise<Dict>;
    privateTradingPostFullV1CancelAllOrders (params?: {}): Promise<Dict>;
    privateTradingPostFullV1Order (params?: {}): Promise<Dict>;
    privateTradingPostFullV1OrderHistory (params?: {}): Promise<Dict>;
    privateTradingPostFullV1OpenOrders (params?: {}): Promise<Dict>;
    privateTradingPostFullV1FillHistory (params?: {}): Promise<Dict>;
    privateTradingPostFullV1Positions (params?: {}): Promise<Dict>;
    privateTradingPostFullV1FundingPaymentHistory (params?: {}): Promise<Dict>;
    privateTradingPostFullV1GetSubAccounts (params?: {}): Promise<Dict>;
    privateTradingPostFullV1AccountSummary (params?: {}): Promise<Dict>;
    privateTradingPostFullV1AccountHistory (params?: {}): Promise<Dict>;
    privateTradingPostFullV1AggregatedAccountSummary (params?: {}): Promise<Dict>;
    privateTradingPostFullV1FundingAccountSummary (params?: {}): Promise<Dict>;
    privateTradingPostFullV1Transfer (params?: {}): Promise<Dict>;
    privateTradingPostFullV1DepositHistory (params?: {}): Promise<Dict>;
    privateTradingPostFullV1TransferHistory (params?: {}): Promise<Dict>;
    privateTradingPostFullV1Withdrawal (params?: {}): Promise<Dict>;
    privateTradingPostFullV1WithdrawalHistory (params?: {}): Promise<Dict>;
    privateTradingPostFullV1AddPositionMargin (params?: {}): Promise<Dict>;
    privateTradingPostFullV1GetPositionMarginLimits (params?: {}): Promise<Dict>;
    privateTradingPostFullV1SetPositionConfig (params?: {}): Promise<Dict>;
    privateTradingPostFullV1SetInitialLeverage (params?: {}): Promise<Dict>;
    privateTradingPostFullV1GetAllInitialLeverage (params?: {}): Promise<Dict>;
    privateTradingPostFullV1SetDeriskMmRatio (params?: {}): Promise<Dict>;
    privateTradingPostFullV1VaultBurnTokens (params?: {}): Promise<Dict>;
    privateTradingPostFullV1VaultInvest (params?: {}): Promise<Dict>;
    privateTradingPostFullV1VaultInvestorSummary (params?: {}): Promise<Dict>;
    privateTradingPostFullV1VaultRedeem (params?: {}): Promise<Dict>;
    privateTradingPostFullV1VaultRedeemCancel (params?: {}): Promise<Dict>;
    privateTradingPostFullV1VaultViewRedemptionQueue (params?: {}): Promise<Dict>;
    privateTradingPostFullV1VaultManagerInvestorHistory (params?: {}): Promise<Dict>;
    privateTradingPostFullV1AuthorizeBuilder (params?: {}): Promise<Dict>;
    privateTradingPostFullV1GetAuthorizedBuilders (params?: {}): Promise<Dict>;
    privateTradingPostFullV1BuilderFillHistory (params?: {}): Promise<Dict>;
}
abstract class Exchange extends _Exchange {}

export default Exchange
